import { render, staticRenderFns } from "./Instruction.vue?vue&type=template&id=33844bcd&scoped=true"
import script from "./Instruction.vue?vue&type=script&lang=js"
export * from "./Instruction.vue?vue&type=script&lang=js"
import style0 from "./Instruction.vue?vue&type=style&index=0&id=33844bcd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33844bcd",
  null
  
)

export default component.exports